import { DisponibilidadHoraria } from '../../domain/entities/DisponibilidadHoraria';
import { DisponibilidadHorariaRepository } from '../../domain/repositories/DisponibilidadHorariaRepository';
import { ApiClient } from '../api/ApiClient';

const decodificarTexto = (texto: string): string => {
  if (!texto) return '';
  const el = document.createElement('textarea');
  el.innerHTML = texto;
  return el.value.trim();
};

export class ApiDisponibilidadHorariaRepository implements DisponibilidadHorariaRepository {
  private apiClient: ApiClient;

  constructor() {
    this.apiClient = new ApiClient();
  }

  async validarDiaHabil(fecha: string): Promise<DisponibilidadHoraria> {
    const respuesta = await this.apiClient.get<{
      success: boolean;
      data: DisponibilidadHoraria;
    }>(`/ValidarDiaHabil?fecha=${encodeURIComponent(fecha)}`);

    return {
      esNoHabil: respuesta.data.esNoHabil,
      mensaje: decodificarTexto(respuesta.data.mensaje)
    };
  }
}
